mapboxgl.accessToken = 'pk.eyJ1IjoiYW9ibG91ayIsImEiOiJjamVhbzVnajIxMXkwMzNsZTFqeTFldnUxIn0.bAGA6PRx08Gp82ed5ON9cA';

var mapIsAnimating = false;

var mapStyles = {
  "Gold Filled" : "mapbox://styles/aoblouk/ck1wple370p4m1cljopdp6zio",
  "Rose Gold Filled" : "mapbox://styles/aoblouk/ck1wplsxf98sn1do8m6qbifmq",
  "Silver" : "mapbox://styles/aoblouk/ck1wpkrao22lv1cnuqs1ddx27",
  "Stainless Steel" : "mapbox://styles/aoblouk/ck1wpjzoi2uqk1co5yrh3n137",
  "default" : "mapbox://styles/aoblouk/ck1wpdpng305p1co4ac0ok7gj"
}

var mapColors = {
  "Gold Filled" : "hsl(45, 100%, 68%)",
  "Rose Gold Filled" : "hsl(6, 88%, 81%)",
  "Silver" : "hsl(180, 13%, 86%)",
  "Stainless Steel" : "hsl(175, 8%, 74%)",
  "default" : "hsl(0, 0%, 100%)"
}

var mapMaterial;

var map = new mapboxgl.Map({
    container: 'main-map', //https://www.mapbox.com/studio/styles/aoblouk/
    style: 'mapbox://styles/aoblouk/cjyuisrg6057k1cp78k9p2s8h',
    zoom: 3,
	preserveDrawingBuffer: true,
    center: [-98.46, 38.77]
});

var jewelryMap = new mapboxgl.Map({
    container: 'jewelry-map', //https://www.mapbox.com/studio/styles/aoblouk/
    style: getJewelryMapStyle(),
    zoom: 3,
	preserveDrawingBuffer: true,
    center: [-98.46, 38.77]
});

var compareMap = new mapboxgl.Compare(map, jewelryMap, {
  mousemove: false
});

var mapWidth = compareMap._bounds.width;

compareMap._setPosition(mapWidth);

map.addControl(new mapboxgl.NavigationControl(), 'top-right');
var geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken
});
map.addControl(geocoder, 'top-left');

map.addControl(new mapboxgl.GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true
}), 'top-right');

map.dragRotate.disable();
map.touchZoomRotate.disableRotation();

var coordinates = document.getElementById('coordinates');
var canvas = map.getCanvasContainer();

var geojson = {
    "type": "FeatureCollection",
    "features": [{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [-98.46, 38.77]
        }
    }]
};

function getJewelryMapStyle()
{
    var titleSplit = $("meta[property='og:title']").attr("content").split(" in ");
    if(titleSplit.length > 1)
    {
        var material = titleSplit[1];
    }
    else
    {
        var material = "default";
      /*
        var urlParams = getUrlVars();
        if(Object.keys(urlParams).contains('mat'))
        {
            var material = urlParams['mat'];
        }
        else
        {
            var material = "default";
        }
       */
    }
  
    mapMaterial = material;
    return mapStyles["default"];
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function setJewelryMapColor(color)
{
    var mapStyle = jewelryMap.getStyle();
    for(var i = 0; i < mapStyle['layers'].length; ++i)
    {
        if(Object.keys(mapStyle['layers'][i]['paint']).includes('line-color'))
        {
            mapStyle['layers'][i]['paint']['line-color'] = color;
        }
    }
    jewelryMap.setStyle(mapStyle);
}

function isJewelryViewActive()
{
  return true;
  return compareMap._x < 0.5;
}

function isMapViewActive()
{
  return true;
  return compareMap._x >= 0.5;
}

function togglePreviewToJewelryView()
{
	var animationTime = 250;
  	if(!mapIsAnimating && isMapViewActive())
    {
        document.getElementById("leftPreviewButton").className = "myButtonLeft";
        document.getElementById("rightPreviewButton").className = "myButtonRightActive";
        mapIsAnimating = true;
        var elapsedTime = 0;
        var speed = -1 * mapWidth / animationTime;
        var timePerStep = 5;
        setTimeout(function () {mapIsAnimating = false}, 250);
        moveSliderDelayed(speed, animationTime, timePerStep);
    }
}

function togglePreviewToMapView()
{
  	var animationTime = 250;
  	if(!mapIsAnimating && isJewelryViewActive())
    {
        document.getElementById("leftPreviewButton").className = "myButtonLeftActive";
        document.getElementById("rightPreviewButton").className = "myButtonRight";
        mapIsAnimating = true;
        var elapsedTime = 0;
        var speed = 1 * mapWidth / animationTime;
        var timePerStep = 5;
        setTimeout(function () {mapIsAnimating = false}, animationTime);
        moveSliderDelayed(speed, animationTime, timePerStep);
    }
}

function moveSliderDelayed(speed, remainingTime, timePerStep)
{
    setTimeout(function() {
        compareMap._setPosition(compareMap._x + speed * timePerStep);
        if(remainingTime > 0 && compareMap._x > 0 && compareMap._x < compareMap._bounds.width)
        {
            moveSliderDelayed(speed, remainingTime - timePerStep, timePerStep);
        }
    }, timePerStep);
}

function onMove(e) {
	var coords = e.lngLat;

    // Set a UI indicator for dragging.
    canvas.style.cursor = 'grabbing';

    // Update the Point feature in `geojson` coordinates
    // and call setData to the source layer `point` on it.
    geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
    //map.getSource('points').setData(geojson);
	
	e.originalEvent.stopPropagation();
	resetEtsyCode();
}

function onUp(e) {
    var coords = e.lngLat;
    canvas.style.cursor = '';

    // Unbind mouse/touch events
    map.off('mousemove', onMove);
    map.off('touchmove', onMove);
	resetEtsyCode();
}

map.on('load', function() {

    // Add a single point to the map
//     map.loadImage('https://cdn.shopify.com/s/files/1/0017/2906/9121/t/2/assets/heartformaps.png?2601965525212072989', function(error, image) {
        if (error) throw error;
//        map.addImage('heart', image);
//         map.addLayer({
//             "id": "points",
//             "type": "symbol",
//             "source": {
//                 "type": "geojson",
//                 "data": {
//                     "type": "FeatureCollection",
//                     "features": [{
//                         "type": "Feature",
//                         "geometry": {
//                             "type": "Point",
//                             "coordinates": [-98.46, 38.77]
//                         }
//                     }]
//                 }
//             },
//             "layout": {
//                 "icon-image": "heart",
//                 "icon-size": .3
//             }
//         });
        onLoad();
//    });

    // When the cursor enters a feature in the point layer, prepare for dragging.
//     map.on('mouseenter', 'points', function() {
//         //map.setPaintProperty('point', 'circle-color', '#555555');
//         canvas.style.cursor = 'move';
//     });

//     map.on('mouseleave', 'points', function() {
//         //map.setPaintProperty('point', 'circle-color', '#000000');
//         canvas.style.cursor = '';
//     });

//     map.on('mousedown', 'points', function(e) {
//         // Prevent the default map drag behavior.
//         canvas.style.cursor = 'grab';

//         map.on('mousemove', onMove);
//         map.once('mouseup', onUp);
//     });

//     map.on('touchstart', 'points', function(e) {
//         if (e.points.length !== 1) return;

//         // Prevent the default map drag behavior.
//         map.on('touchmove', onMove);
//         map.once('touchend', onUp);
//     });
});

function getOrientation()
{
	var lat = map.getCenter().lat;
	var lng = map.getCenter().lng;
	var zoom = map.getZoom();
    var orientation = map.getBearing();
    var pitch = map.getPitch();
  
  	var text = "";
  	var fontSize = "";
  	var font = "";
	if(document.getElementById("backText"))
    {
    	text = document.getElementById('backText').value;
    	fontSize = document.getElementById('fontSize').value;
    	font = document.getElementById('backTextFont').value;
    }
    return {"lat": lat, "lng": lng, "zoom": zoom, "orientation": orientation, "pitch": pitch, "featureLat": geojson.features[0].geometry.coordinates[1], "featureLng": geojson.features[0].geometry.coordinates[0], "text": text, "fontSize": fontSize, "font": font};
}
//map.setBearing allows for rotation

function setOrientation(lat, lng, zoom, orientation, pitch, featureLat, featureLng, text, fontSize, font)
{
	map.setCenter({"lng": lng, "lat": lat});
	map.setZoom(zoom);
    map.rotateTo(orientation);
    map.setPitch(pitch);
    geojson.features[0].geometry.coordinates = [featureLng, featureLat];
    //map.getSource('points').setData(geojson);
  
  	if(document.getElementById("backText"))
    {
    	document.getElementById('backTextFont').value = font;
    	document.getElementById('fontSize').value = fontSize;
    	document.getElementById('backText').value = text;
    }
}

function saveOrientation()
{
	getOrientation();
	setCookie("orientation", JSON.stringify(getOrientation()));
	//call this using event listeners
	//save to local storage (set a cookie for shopify to extract text info)
}

function loadOrientation()
{
	var data = JSON.parse(getCookie("orientation"));
	setOrientation(data.lat, data.lng, data.zoom);
}

function setCookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (180 * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

jQuery(function () {
	jQuery('.zoomin').click(function (event) {
		event.preventDefault();
		map.zoomIn();
      resetEtsyCode();
	});
	jQuery('.zoomout').click(function (event) {
		event.preventDefault();
		map.zoomOut();
      resetEtsyCode();
	});
	jQuery(window).resize(function () {
		var currentMapWidth = jQuery('#map').width();
		jQuery('#overlay, #main_overlayimage, #cutout_overlayimage').width(currentMapWidth);
		jQuery('#main_overlayimage, #cutout_overlayimage').height(jQuery('#map').height());
	}).resize();
});

jewelryMap.on('load', function() {
    setJewelryMapColor(mapColors[mapMaterial]);
    setOverlayColor();
});
//map.on('load', onLoad); // set proximity on map load
map.on('moveend', updateGeocoderProximity); // and then update proximity each time the map moves

function onLoad()
{
  var url = new URL(window.location.href);
  var orientation = url.searchParams.get("orientation");
  //var city = url.searchParams.get("city");
  if(orientation != null && orientation != "")
  {
    var data = JSON.parse(orientation);
    setOrientation(data.lat, data.lng, data.zoom, data.orientation, data.pitch, data.featureLat, data.featureLng, data.text, data.fontSize, data.font);
  }
  else
  {
    var splitTitle = $("meta[property='og:title']").attr("content").split("City");
    if(splitTitle[1]) 
    {
      setCity(splitTitle[0]);
    }
  }
  updateGeocoderProximity();
}

function setCity(cityName) 
{
  var geocodeURL = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURI(cityName) + ".json?access_token=pk.eyJ1IjoiYW9ibG91ayIsImEiOiJjamVhbzVnajIxMXkwMzNsZTFqeTFldnUxIn0.bAGA6PRx08Gp82ed5ON9cA&country=us&types=place";
  jQuery.get(geocodeURL, function(response) {
    var coordinates = response.features[0].center;
    setOrientation(coordinates[1],coordinates[0],12.75,0,0);
    geojson.features[0].geometry.coordinates = [coordinates[0] - 0.005, coordinates[1] + 0.005];
    //map.getSource('points').setData(geojson);
    resetEtsyCode();
  });
}

function updateGeocoderProximity() {
    // proximity is designed for local scale, if the user is looking at the whole world,
    // it doesn't make sense to factor in the arbitrary centre of the map
    if (map.getZoom() > 9) {
        var center = map.getCenter().wrap(); // ensures the longitude falls within -180 to 180 as the Geocoding API doesn't accept values outside this range
        geocoder.setProximity({ longitude: center.lng, latitude: center.lat });
    } else {
        geocoder.setProximity(null);
    }
	
	//if the point goes outside the bounds of the map then remove it
	if(!(
		map.getBounds()._ne.lng > geojson.features[0].geometry.coordinates[0] && 
		map.getBounds()._sw.lng < geojson.features[0].geometry.coordinates[0] && 
		map.getBounds()._ne.lat > geojson.features[0].geometry.coordinates[1] && 
		map.getBounds()._sw.lat < geojson.features[0].geometry.coordinates[1]
	))
	{
		geojson.features[0].geometry.coordinates = [map.getCenter().lng, map.getCenter().lat];
		//map.getSource('points').setData(geojson);
	}
	resetEtsyCode();
}

var imageBlob;
var isSaved = false;

function drawToMap(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var mapCanvas = document.getElementsByClassName("mapboxgl-canvas")[0];
      var canvasRead2 = document.createElement('canvas');
      canvasRead2.width = img.width;
      canvasRead2.height = img.height;
      canvasRead2.getContext('2d').drawImage(mapCanvas, 0, 0, mapCanvas.width, mapCanvas.height, 0, 0, img.width, img.height);
      var canvasRead2Data = canvasRead2.getContext('2d').getImageData(0, 0, img.width, img.height);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 460)
              {
                  if(j < lowestJ) lowestJ = j;
                  if(j > highestJ) highestJ = j;
                  if(i < lowestI) lowestI = i;
                  if(i > highestI) highestI = i;
                  canvasDataToWrite.data[index + 0] = 0;
                  canvasDataToWrite.data[index + 1] = 0;
                  canvasDataToWrite.data[index + 2] = 0;
                  canvasDataToWrite.data[index + 3] = canvasRead2Data.data[index + 3];
              }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      //var img = canvasWrite.toDataURL("image/png", 1.0);
      
      //imageBlob = dataURItoBlob(img);
	  //document.getElementById("File 1").setAttribute("value", img);
	  document.getElementById("Orientation").setAttribute("value", JSON.stringify(getOrientation()));
      
      try {
        const dT = new ClipboardEvent('').clipboardData || // Firefox < 62 workaround exploiting https://bugzilla.mozilla.org/show_bug.cgi?id=1422655
        new DataTransfer(); // specs compliant (as of March 2018 only Chrome)
        dT.items.add(new File([dataURItoBlob(img)], 'image.png'));
        document.getElementById("File 2").files = dT.files;
      } catch(err){}
      
      document.getElementById("product-form").submit();
    }
}

function setOverlayColor()
{
    var image = new Image();
    image.onload = function()
    {
        var overlayImage = this;
    	var canvas = document.createElement('canvas');
        var color = jewelryMap.getStyle()['layers'][1]['paint']['line-color'];
    	canvas.width = overlayImage.width;
    	canvas.height = overlayImage.height;
   		var context = canvas.getContext('2d');
    	context.drawImage(overlayImage, 0, 0);
    	context.fillStyle = color;
    	context.globalCompositeOperation = "multiply";
    	context.fillRect(0, 0, 1000, 1000);
    	context.globalCompositeOperation = 'destination-in';
    	context.drawImage(overlayImage, 0, 0);  
        if($("#cutout_overlayimage").prop("tagName") == 'IMG')
        {
          $("#cutout_overlayimage").attr("src", canvas.toDataURL('image/png'));
        }
        else
        {
          $("#cutout_overlayimage").css("background", "url('" + canvas.toDataURL('image/png') + "') no-repeat 50% 50%");
        }
    }
  	image.crossOrigin = "Anonymous";
    if($("#cutout_overlayimage").prop("tagName") == 'IMG')
    {
      var imgSrc = $("#cutout_overlayimage").attr("src");
    }
    else
    {
      var imgSrc = $("#cutout_overlayimage").css("background").split("url(\"")[1].split("\")")[0];
    }
    image.src = imgSrc;
}

function drawToMap2(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var mapCanvas = document.getElementsByClassName("mapboxgl-canvas")[0];
      var canvasRead2 = document.createElement('canvas');
      canvasRead2.width = img.width;
      canvasRead2.height = img.height;
      canvasRead2.getContext('2d').drawImage(mapCanvas, 0, 0, mapCanvas.width, mapCanvas.height, 0, 0, img.width, img.height);
      var canvasRead2Data = canvasRead2.getContext('2d').getImageData(0, 0, img.width, img.height);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 460)
              {
                  if(j < lowestJ) lowestJ = j;
                  if(j > highestJ) highestJ = j;
                  if(i < lowestI) lowestI = i;
                  if(i > highestI) highestI = i;
                  canvasDataToWrite.data[index + 0] = 0;
                  canvasDataToWrite.data[index + 1] = 0;
                  canvasDataToWrite.data[index + 2] = 0;
                  canvasDataToWrite.data[index + 3] = canvasRead2Data.data[index + 3];
              }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      //var img = canvasWrite.toDataURL("image/png", 1.0);
      
      //imageBlob = dataURItoBlob(img);
	  //document.getElementById("File 1").setAttribute("value", img);
      var dataObject = getOrientation();
      
	  document.getElementById("etsyCode").value = JSON.stringify(dataObject);
    }
}

function drawToOutput(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width;
      canvasRead.height = img.height;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width, img.height);

      var gl = map.getCanvas().getContext('webgl', {preserveDrawingBuffer: true});
	  var canvasRead2Data = new Uint8Array(gl.drawingBufferWidth * gl.drawingBufferHeight * 4);
	  gl.readPixels(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, canvasRead2Data);
      
      var halfHeight = gl.drawingBufferHeight / 2 | 0;  // the | 0 keeps the result an int
      var bytesPerRow = gl.drawingBufferWidth * 4;
      // make a temp buffer to hold one row
      var temp = new Uint8Array(bytesPerRow);
      for (var y = 0; y < halfHeight; ++y) {
        var topOffset = y * bytesPerRow;
        var bottomOffset = (gl.drawingBufferHeight - y - 1) * bytesPerRow;
        // make copy of a row on the top half
        temp.set(canvasRead2Data.subarray(topOffset, topOffset + bytesPerRow));
        // copy a row from the bottom half to the top
        canvasRead2Data.copyWithin(topOffset, bottomOffset, bottomOffset + bytesPerRow);
        // copy the copy of the top half row to the bottom half 
        canvasRead2Data.set(temp, bottomOffset);
      }

      var canvasWrite = document.createElement('canvas');
      canvasWrite.style.imageRendering = "-moz-crisp-edges -webkit-crisp-edges pixelated crisp-edges";
      canvasWrite.width = img.width;
      canvasWrite.height = img.height;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width, img.height);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height; j++)
      {
          for(var i=0; i<img.width; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && canvasRead2Data[index + 3] > 0 && (canvasRead2Data[index + 0] + canvasRead2Data[index + 1] + canvasRead2Data[index + 2]) < 690)
              {
                  canvasDataToWrite.data[index + 0] = canvasRead2Data[index + 0];
                  canvasDataToWrite.data[index + 1] = canvasRead2Data[index + 1];
                  canvasDataToWrite.data[index + 2] = canvasRead2Data[index + 2];
                  canvasDataToWrite.data[index + 3] = 255;
              }
              else
              {
                  canvasDataToWrite.data[index + 0] = 255;
                  canvasDataToWrite.data[index + 1] = 255;
                  canvasDataToWrite.data[index + 2] = 255;
                  canvasDataToWrite.data[index + 3] = 255;
              }
            if(canvasReadData.data[index + 3] == 0)
            {
              if(j < lowestJ) lowestJ = j;
              if(j > highestJ) highestJ = j;
              if(i < lowestI) lowestI = i;
              if(i > highestI) highestI = i;
            }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = highestI-lowestI;
      canvasWrite.height = highestJ-lowestJ;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, highestI-lowestI, highestJ-lowestJ);
      var imgOut = canvasWrite.toDataURL("image/png", 1.0);
      
	  document.getElementById("outputFile").innerHTML = "<img src='"+imgOut+"'>";
      
      drawTextToOutput(imageReference);
    }
}

function drawTextToOutput(imageReference)
{
	var img = new Image();
	img.src = assets[imageReference];
      
    img.onload = function()
    {
      var img = this;
      var canvasRead = document.createElement('canvas');
      canvasRead.width = img.width*2;
      canvasRead.height = img.height*2;
      canvasRead.getContext('2d').drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width*2, img.height*2);
      var canvasReadData = canvasRead.getContext('2d').getImageData(0, 0, img.width*2, img.height*2);
      var canvasRead2Data = backCanvas.getContext("2d").getImageData(0, 0, img.width*2, img.height*2);

      var canvasWrite = document.createElement('canvas');
      canvasWrite.style.imageRendering = "-moz-crisp-edges -webkit-crisp-edges pixelated crisp-edges";
      canvasWrite.width = img.width*2;
      canvasWrite.height = img.height*2;
      var canvasDataToWrite = canvasWrite.getContext('2d').getImageData(0, 0, img.width*2, img.height*2);

      var lowestJ = 99999;
      var highestJ = -1;
      var lowestI = 99999;
      var highestI = -1;
      var index = 0;
      for(var j=0; j<img.height*2; j++)
      {
          for(var i=0; i<img.width*2; i++)
          {
              if(canvasReadData.data[index + 3] == 0 && canvasRead2Data.data[index + 3] > 0 && (canvasRead2Data.data[index + 0] + canvasRead2Data.data[index + 1] + canvasRead2Data.data[index + 2]) < 690)
              {
                  canvasDataToWrite.data[index + 0] = canvasRead2Data.data[index + 0];
                  canvasDataToWrite.data[index + 1] = canvasRead2Data.data[index + 1];
                  canvasDataToWrite.data[index + 2] = canvasRead2Data.data[index + 2];
                  canvasDataToWrite.data[index + 3] = 255;
              }
              else
              {
                  canvasDataToWrite.data[index + 0] = 255;
                  canvasDataToWrite.data[index + 1] = 255;
                  canvasDataToWrite.data[index + 2] = 255;
                  canvasDataToWrite.data[index + 3] = 255;
              }
            if(canvasReadData.data[index + 3] == 0)
            {
              if(j < lowestJ) lowestJ = j;
              if(j > highestJ) highestJ = j;
              if(i < lowestI) lowestI = i;
              if(i > highestI) highestI = i;
            }
              index+=4;
          }
      }

      canvasRead.getContext('2d').clearRect(0,0,canvasRead.width,canvasRead.height);
      canvasRead.getContext('2d').putImageData(canvasDataToWrite, 0, 0);
      canvasWrite.width = (highestI-lowestI)/2;
      canvasWrite.height = (highestJ-lowestJ)/2;
      canvasWrite.getContext('2d').drawImage(canvasRead, lowestI, lowestJ, highestI-lowestI, highestJ-lowestJ, 0, 0, (highestI-lowestI)/2, (highestJ-lowestJ)/2);
      var imgOut = canvasWrite.toDataURL("image/png", 1.0);
      
	  document.getElementById("outputFile").innerHTML += "<img src='"+imgOut+"'>";
    }
}

function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
  }


  
  
  var backCanvas = document.getElementById("pendantBackCanvas");
  var BCANVAS = backCanvas.getContext("2d");

  function renderBack()
  {
	  if(!document.getElementById("backText")) return;
    
      BCANVAS.font= "1px Monotype Corsiva";
      BCANVAS.fillText("Load font", 0, 0);
      BCANVAS.font= "1px monospace";
      BCANVAS.fillText("Load font", 0, 0);
      BCANVAS.font= "1px Courier New";
      BCANVAS.fillText("Load font", 0, 0);
    
      BCANVAS.restore();
      BCANVAS.clearRect(0,0,backCanvas.width,backCanvas.height);
      BCANVAS.font= document.getElementById("fontSize").value+"px "+document.getElementById("backTextFont").value;
      var textValue = document.getElementById("backText").value;
      var textLines = textValue.split("\n");
      for(var i=0; i<textLines.length; i++)
      {
          BCANVAS.fillText(textLines[i], 500 - (BCANVAS.measureText(textLines[i]).width/2), 500 - ((document.getElementById("fontSize").value * .3) * textLines.length) + (document.getElementById("fontSize").value * i));
      }
      BCANVAS.save();
  }

  function openTab(evt, tabName) {
      // Declare all variables
      var i, tabcontent, tablinks;

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      document.getElementById(tabName).style.display = "block";
      evt.currentTarget.className += " active";
    
	  var displayStatus = document.getElementById("pendantBack").style.display;
      if(displayStatus == "block") displayStatus = "inline-block";
      document.getElementById("backInfo").style.display = displayStatus;
  }

function resetEtsyCode()
{
  	if(document.getElementById("etsyCode"))
    {
      document.getElementById("etsyCode").value = '';
    }
}